module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_retouch-9ac8d015f769eca832c4e01378cefe4c.jpg";